/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Damper_OutsideInputs */



/**
* | output |
* | --- |
* | "Fresh air damper" |
*
* @param {Air_Handler_Unit_Damper_OutsideInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_damper_outside = /** @type {((inputs?: Air_Handler_Unit_Damper_OutsideInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Damper_OutsideInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Fresh air damper")
	return /** @type {LocalizedString} */ ("Volet d'air neuf")
});